import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWheelchairNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g
        clipPath="url(#sports_wheelchair_normal_large_svg__clip0_138_91)"
        fill=""
      >
        <path d="M11 29a6 6 0 100-12 6 6 0 000 12zm0-10a4 4 0 110 8 4 4 0 010-8z" />
        <path d="M11 34a11 11 0 009.22-5h15.87a6 6 0 101.07-4.54l-7.286-3.871A1.644 1.644 0 0129 19.134V17h-2v2.134a3.64 3.64 0 001.935 3.22l1.214.646H22a11 11 0 10-11 11zm27.08-6.78L42 29.3v-2.26l-3.05-1.62a4.03 4.03 0 11-.87 1.8zM21.82 25h12.09l2.35 1.25a4.555 4.555 0 00-.17.75H21.25c.252-.648.442-1.317.57-2zM11 14a9 9 0 11-9 9 9.014 9.014 0 019-9z" />
      </g>
      <defs>
        <clipPath id="sports_wheelchair_normal_large_svg__clip0_138_91">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsWheelchairNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsWheelchairNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWheelchairNormalLarge;
